export enum TwoTypeAuth {
  email = 'email',
  phone = 'phone',
}
